import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets.app/images/onboarding/check.svg'
import _imports_1 from '@/assets.app/images/onboarding/stars.svg'


const _hoisted_1 = { class: "onboarding-finishing" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "onboarding-finishing__progress" }
const _hoisted_4 = { class: "onboarding-finishing__progress-label" }
const _hoisted_5 = { class: "onboarding-finishing__steps" }
const _hoisted_6 = { class: "onboarding-finishing__step-title" }
const _hoisted_7 = {
  key: 0,
  class: "onboarding-finishing__status onboarding-finishing__status--prev"
}
const _hoisted_8 = {
  key: 2,
  class: "onboarding-finishing__status onboarding-finishing__status--next"
}
const _hoisted_9 = {
  key: 0,
  class: "onboarding-finishing__reviews"
}
const _hoisted_10 = {
  key: 0,
  class: "onboarding-finishing__popup"
}
const _hoisted_11 = { class: "onboarding-finishing__popup-inner" }
const _hoisted_12 = { class: "onboarding-finishing__popup-title" }
const _hoisted_13 = { class: "onboarding-finishing__popup-controls" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import {
  FinishingSetupChoice,
  FinishingSetupPage,
  FinishingSetupPageSteps,
} from '@/models/onboarding.types'

import FinishingSetupSpinner from '../FinishingSetupSpinner.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FinishingSetup',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as FinishingSetupPage
})

const pageTitle = computed(() => {
  if (finishedLoading.value) {
    return page.value.title
  }

  return page.value.titleLoading
})

const currentStepIndex = ref(0)
const currentQuestion = computed(() => {
  return page.value.steps[currentStepIndex.value].question
})

const finishedLoading = ref(false)

const showQuestionPopup = ref(false)

const nextQuestionThreshold = computed(() => {
  return (currentStepIndex.value + 1) * (100 / page.value.steps.length)
})

const currentChoice = computed(() => {
  return props.view.currentChoice as FinishingSetupChoice
})

function submitAnswer(answer: boolean): void {
  if (answer === true) {
    props.view.setCurrentChoice([...currentChoice.value, currentQuestion.value])
  }

  if (currentStepIndex.value + 1 === page.value.steps.length) {
    finishedLoading.value = true
    showQuestionPopup.value = false
    props.view.showContinueButton()
    return
  }

  showQuestionPopup.value = false
  startInterval()
  currentStepIndex.value++
}

function getStepTitle(
  step: FinishingSetupPageSteps,
  stepIndex: number,
): string {
  if (stepIndex >= currentStepIndex.value && !finishedLoading.value) {
    return step.titleLoading
  }

  return step.title
}

const updateProgressInterval = ref<number | null>(null)
const loadingProgress = ref(0)

function startInterval(): void {
  if (updateProgressInterval.value) {
    return
  }

  updateProgressInterval.value = setInterval(() => {
    loadingProgress.value += 2
  }, 150)

  showQuestionPopup.value = false
}

function stopInterval(): void {
  if (updateProgressInterval.value) {
    clearInterval(updateProgressInterval.value)
    updateProgressInterval.value = null
  }
}

watch(loadingProgress, (newValue) => {
  if (newValue >= nextQuestionThreshold.value) {
    stopInterval()
    showQuestionPopup.value = true
  }
})

onMounted(() => {
  // The default value of `view.currentChoice` is `undefined`.
  // The value of the choices for this page is an array, so
  // we set the initial value of `view.currentChoice` to an
  // empty array so that we can spread the current value
  // without having to check if it's an array first.
  props.view.setCurrentChoice([])
  startInterval()
})

onUnmounted(() => {
  stopInterval()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      class: "onboarding-finishing__title",
      innerHTML: pageTitle.value
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "onboarding-finishing__progress-bar",
        style: _normalizeStyle({
          '--current-progress': `${loadingProgress.value}%`,
        })
      }, null, 4),
      _createElementVNode("p", _hoisted_4, _toDisplayString(loadingProgress.value) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.steps, (step, index) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: step.title,
          name: "swap-state",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: getStepTitle(step, index),
              class: _normalizeClass(["onboarding-finishing__step", {
            'onboarding-finishing__step--prev':
              index < currentStepIndex.value || finishedLoading.value,
            'onboarding-finishing__step--current':
              index === currentStepIndex.value && !finishedLoading.value,
            'onboarding-finishing__step--next': index > currentStepIndex.value,
          }])
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "onboarding-finishing__step-dot" }, null, -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(getStepTitle(step, index)), 1),
              (index < currentStepIndex.value || finishedLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      class: "onboarding-finishing__icon",
                      src: _imports_0,
                      alt: ""
                    }, null, -1)
                  ]))]))
                : (index === currentStepIndex.value)
                  ? (_openBlock(), _createBlock(FinishingSetupSpinner, {
                      key: 1,
                      class: "onboarding-finishing__status onboarding-finishing__status--current"
                    }))
                  : _createCommentVNode("", true),
              (index > currentStepIndex.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ], 2))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    (!__props.view.isContinueButtonVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            class: "onboarding-finishing__stars"
          }, null, -1),
          _createElementVNode("p", { class: "onboarding-finishing__review" }, "Enjoyed by 1M+ users", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
      _createVNode(_Transition, { name: "popup-pop" }, {
        default: _withCtx(() => [
          (showQuestionPopup.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "onboarding-finishing__popup-label" }, " To continue, answer: ", -1)),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(currentQuestion.value), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(AppButton, {
                      class: "onboarding-finishing__popup-button onboarding-finishing__popup-button--no",
                      outlined: true,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (submitAnswer(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("No", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(AppButton, {
                      class: "onboarding-finishing__popup-button onboarding-finishing__popup-button--yes",
                      outlined: true,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (submitAnswer(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Yes", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})